/*
 * @Author: edvardchen
 * @Date: 2017-11-13 09:35:53
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-03-20 23:02:12
 */

// @flow
import { HIDE_OPTIONS, PRAISE_COMMENT, SHOW_OPTIONS } from './actions';
import { type Action, type Comment } from '../types';

const reducer = (state: Comment, { type, payload = {} }: Action) => {
  const { showOptions } = (state: Object);

  switch (type) {
    case HIDE_OPTIONS: {
      if (!showOptions) {
        return state;
      }
      return {
        ...state,
        showOptions: false,
      };
    }
    case SHOW_OPTIONS: {
      if (showOptions || state.id !== payload.id) {
        return state;
      }
      return {
        ...state,
        showOptions: true,
      };
    }
    case PRAISE_COMMENT: {
      const { id, praiseNum, praised } = state;
      if (id !== payload.id || praised) {
        return state;
      }
      return {
        ...state,
        praised: true,
        praiseNum: payload.praised ? praiseNum || 0 : (praiseNum || 0) + 1,
      };
    }
    default:
      return state;
  }
};

export default reducer;
